import { roofFaceFromJSON, RoofFaceRecord } from "common/records/RoofFace";
import { RootActions, RootState } from "common/reducers";
import { RECEIVE_ROOF_FACE } from "common/reducers/roofFace.actions";
import { receive } from "common/reducers/Utils";
import { Map, Record } from "immutable";

export const RoofFaceStateRecord = Record({
  byId: Map<number, RoofFaceRecord>(),
  lastSavedById: Map<number, RoofFaceRecord>(),
  unsavedId: -1,
});

export const initialState = RoofFaceStateRecord();

export type RoofFaceState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  const model = "roofFaces";
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_ROOF_FACE:
      return receive(state, model, roofFaceFromJSON(action.payload.roofFace));

    default:
      return state;
  }
};
